module.exports = __webpack_public_path__ + "img/canada-external-causes-female.3de5a818.png";